"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { Button } from "@nextui-org/react";
import { useAppSelector } from "@/redux/hooks";
import BottomSheet from "./BottomSheet";

export default function VpnWarningSheet() {
  const pathname = usePathname();
  const isIran = useAppSelector((state) => state.Network?.isIran);
  const [dismissed, setDismissed] = useState(false);
  const isHome = pathname === "/";
  const open = isHome && isIran === false && !dismissed;

  useEffect(() => {
    if (isHome) setDismissed(false);
  }, [isHome, pathname]);

  const dismiss = () => setDismissed(true);

  return (
    <BottomSheet
      open={open}
      onClose={dismiss}
      title="اتصال به VPN شناسایی شد"
      maxHeight="70vh"
      zIndex={100001}
    >
      <div className="flex flex-col items-center gap-5 pt-2 text-center">
        <div
          className="flex size-14 items-center justify-center rounded-full border border-amber-400/30 bg-amber-400/10 text-3xl"
          aria-hidden="true"
        >
          !
        </div>
        <p className="max-w-md text-sm leading-8 text-white/80 md:text-base">
          به نظر می‌رسد با VPN به منه‌باخ متصل شده‌اید. برای پایداری بیشتر پخش
          و کیفیت بهتر، لطفاً VPN خود را خاموش کنید و سپس ادامه دهید.
        </p>
        <Button
          color="danger"
          size="lg"
          className="w-full max-w-sm font-bold"
          onPress={dismiss}
        >
          متوجه شدم
        </Button>
      </div>
    </BottomSheet>
  );
}
